// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__24YWY","left":"StickyBox_left__2NVAQ","right":"StickyBox_right__2KG1J"};